/** The steps of `/login` before a code is sent. */
export const LOGIN_STEPS = {
    // Phone or email, one in the field and the other as a button above it.
    START: "start",
    // The email is known: its password, or a code by email on request.
    PASSWORD: "password",
}

export const LOGIN_MODES = { EMAIL: "email", PHONE: "phone" }

/**
 * `/login/password` (the fast-track's « Accéder à la plateforme ») and a known
 * email (an expired account on « Qui utilise Masteur ? ») open on the password
 * step; anything else starts from the beginning.
 */
export const initialLoginStep = (routeName, prefillEmail) =>
    routeName === "login/password" || prefillEmail
        ? LOGIN_STEPS.PASSWORD
        : LOGIN_STEPS.START

/**
 * « Continuer » on the first step. A number is an explicit choice of the SMS
 * code; an email only leads to its password step — no code is sent from here.
 */
export const START_ACTIONS = { SEND_SMS: "send_sms", PASSWORD_STEP: "password" }

/** The first step's primary button names the way in the field offers. */
export const startContinueLabel = (mode) =>
    mode === LOGIN_MODES.PHONE
        ? "Continuer avec le numéro de téléphone"
        : "Continuer avec l'e-mail"

export const startAction = (mode) =>
    mode === LOGIN_MODES.PHONE
        ? START_ACTIONS.SEND_SMS
        : START_ACTIONS.PASSWORD_STEP

/** What the header's back arrow does, from the innermost step outwards. */
export const BACK_ACTIONS = {
    LEAVE_CODE: "leave_code", // back to the step that asked for the code
    TO_START: "to_start",
    LEAVE_SCREEN: "leave_screen",
}

export const backAction = ({ codeSent, step }) => {
    if (codeSent) return BACK_ACTIONS.LEAVE_CODE
    if (step !== LOGIN_STEPS.START) return BACK_ACTIONS.TO_START
    return BACK_ACTIONS.LEAVE_SCREEN
}

/** The identifier a code is asked for: the number on the phone field only. */
export const codeIdentifier = ({ step, mode, email, phone }) =>
    step === LOGIN_STEPS.START && mode === LOGIN_MODES.PHONE ? phone : email
